import { inject, Injectable } from '@angular/core';
import { BlobServiceClient } from '@azure/storage-blob';
import { environment } from '../../../../environments/environment';
import { ConfigService } from '../../configservices/sasTokenConfig';

@Injectable({
  providedIn: 'root',
})
export class ConnectiveservicesService {
  private config = inject(ConfigService);
  sub_organizationdata: any;
  academic_calendar_data: any;
  start_leave_date: any;
  number_of_selected_days: any;
  Employee_data: any;
  userdata: any;
  // selected_class_date: any;
  accessUrl = environment.ASSET_BLOB_URL;
  containerName = environment.ASSET_CONTAINER;

  constructor() {}

  get_selected_sub_organization() {
    if (sessionStorage.getItem('SubOrgData')) {
      this.sub_organizationdata = sessionStorage.getItem('SubOrgData');
      return JSON.parse(this.sub_organizationdata);
    } else {
      return undefined;
    }
  }

  getuserdata() {
    if (sessionStorage.getItem('user')) {
      this.userdata = sessionStorage.getItem('user');
      return JSON.parse(this.userdata);
    } else {
      return undefined;
    }
  }

  get_Employee_data() {
    return this.Employee_data;
  }

  get_academic_calendar_data() {
    return this.academic_calendar_data;
  }

  get_number_of_selected_days() {
    return this.number_of_selected_days;
  }

  get_start_leave_date() {
    return this.start_leave_date;
  }

  // get_selected_class_date(){
  //   return this.selected_class_date;
  // }

  async uploadFile(
    file: File,
    websiteId: number,
    folderPath: string,
  ): Promise<string> {
    const storedWebsiteDetails = sessionStorage.getItem('websiteDetails');
    let websiteDomainName = '';
    let uploadPath = '';
    let parsedDetails: any = null;

    if (storedWebsiteDetails) {
      try {
        parsedDetails = JSON.parse(storedWebsiteDetails);
        if (Array.isArray(parsedDetails) && parsedDetails.length > 0) {
          parsedDetails.forEach((website: any) => {
            if (website.id === websiteId) {
              websiteDomainName = website.website_url
                .replace(/^(https?:\/\/)?(www\.)?/, '')
                .replace(/\/$/, '');
              uploadPath = `${website.name}/${websiteDomainName}/${folderPath}`;
            }
          });
        }
      } catch (err) {
        console.error('Error parsing websiteDetails:', err);
      }
    }
    const dynamicSASUrl = await this.config.getStorageConnection();

    const blobServiceClient = new BlobServiceClient(dynamicSASUrl);
    const containerClient = blobServiceClient.getContainerClient(
      this.containerName,
    );
    const blobPath = `${uploadPath}/${file.name}`;
    const blockBlobClient = containerClient.getBlockBlobClient(blobPath);

    await blockBlobClient.uploadBrowserData(file, {
      blobHTTPHeaders: { blobContentType: file.type },
    });

    return blockBlobClient.url;
  }
}
